import { actions } from "../../js/state-machine/index";
import * as events from "../../js/state-machine/events";
import { prefix } from "../../design-tokens/meta";
import { matchers } from "../../js/validate-props";

export const componentName = "Tag";

export const defaultProps = Object.freeze({
    dismiss: false,
    srDismiss: "dismiss",
});

export const schema = Object.freeze({
    dismiss: matchers.boolean,
    srDismiss: matchers.minChars(1),
});

export const eventMap = Object.freeze({
    [actions.dismiss().type]: events.dismiss(componentName),
});

export const componentClasses = Object.freeze({
    base: `${prefix}tag`,
    colors: {
        blue: "", // Default
        green: `${prefix}tag--green`,
        yellow: `${prefix}tag--yellow`,
        orange: `${prefix}tag--orange`,
        red: `${prefix}tag--red`,
        berry: `${prefix}tag--berry`,
        purple: `${prefix}tag--purple`,
        gray: `${prefix}tag--gray`,
    },
    inactive: `${prefix}tag--inactive`,
    sizes: {
        lg: "", // Default
        md: `${prefix}tag--md`,
        sm: `${prefix}tag--sm`,
    },
});

export const views = Object.freeze({
    inactive: { attrs: { "aria-disabled": "true" } },
});

export const icons = Object.freeze({
    // This icon is completely custom to the tag component. It is not part of our library and should not
    // live outside this file. This was a design requirement because the close-x icon we had was not
    close: `<svg viewBox="0 0 8.485 8.486"><path d="M.707,0,0,.707,3.536,4.243,0,7.778l.707.708L4.243,4.95,7.778,8.485l.707-.707L4.95,4.243,8.485.707,7.778,0,4.243,3.536Z"/></svg>`,
});
